
import { defineComponent, PropType } from 'vue'
import { iChangedData } from '../../Metaweb'
import { filterDefault } from '@/helpers/commons/filterHelper'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import metawebPhysicalModelUpdateDialogDescriptor from './MetawebPhysicalModelUpdateDialogDescriptor.json'

export default defineComponent({
    name: 'metaweb-update-changed-lists',
    components: { Column, DataTable },
    props: { changedItem: { type: Object as PropType<iChangedData | null> } },
    emits: ['selected'],
    data() {
        return {
            metawebPhysicalModelUpdateDialogDescriptor,
            data: null as iChangedData | null,
            rows: [] as { value: string }[],
            selectedTables: [] as string[],
            filters: {
                global: [filterDefault]
            } as Object
        }
    },
    watch: {
        changedItem() {
            this.loadData()
        }
    },
    async created() {
        this.loadData()
    },
    methods: {
        loadData() {
            this.data = this.changedItem as iChangedData
            this.loadRows()
        },
        loadRows() {
            this.rows = []
            this.data?.missingTables?.forEach((el: any) => this.rows.push({ value: el }))
        },
        onTablesSelect() {
            this.$emit('selected', this.selectedTables)
        }
    }
})
